/*eslint-disable no-prototype-builtins */
/*eslint-disable no-undef */
/*eslint-disable no-irregular-whitespace */
import React, { Component } from 'react';
import {
  GoogleMap,
  withGoogleMap,
  withScriptjs,
  OverlayView,
  Marker,
  DirectionsRenderer,
} from 'react-google-maps';

import LoadingIndicator from '../../../../../components/LoadingIndicator';
import iconDriver from '../../../../../assets/images/icn_delivery-drivers-truck.png';
import iconAwaitingDelivery from '../../../../../assets/images/icn_delivery-awaiting-delivery-full.png';
import iconDelivered from '../../../../../assets/images/icn_delivery-delivered.png';
import ThrowMapError from '../ThrowMapError';
import DeliveryPointInfo from './DelivreyPointInfo';
import CustomOverlayView from './CustomOverlayView';

import { mapCenterCalculate } from '../../../../../utils/map-center-calculate'

import { LoaderContainer } from './styles';

import { ERROR_TYPE, ERROR_DETAIL } from '../enums';

const DRIVER_ROUTE_COLOR = '#42adf5';
const MAP_ROUTE_COLOR = '#c0c0c0';
const DEFAULT_STROKE_OPACITY = 1;
const DEFAULT_STROKE_WEIGHT = 8;

let directionsResultsReturned = 0;

class Map extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
      directionsServiceUI: {
        data: null,
        error: null,
        status: null,
      },
      driverDirectionsServiceUI: {
        data: null,
        error: null,
        status: null,
      },
      activeDeliveryPointInfo: {
        data: [],
        lat: null,
        lng: null,
        isVisible: false,
      },
      errorDetail: {
        message: null,
        icon: null,
        color: null,
        type: null,
      },
      mapCenter: {
        lat: this.props.manifestInformation.driver.currentLatitude,
        lng: this.props.manifestInformation.driver.currentLongitude,
      },
    };
    this.mapRef = React.createRef();
  }

  async componentDidMount() {
    await this._setMapDirections();
    this._setDriverDirections();
  }

  _setMultiArray = checkpoints => {
    const batches = [];
    const itemsPerBatch = 25; // google API max = 10 - 1 start, 1 stop, and 8 waypoints
    let itemsCounter = 0;
    let wayptsExist = checkpoints && checkpoints.length > 0;

    while (wayptsExist) {
      const subBatch = [];
      let subitemsCounter = 0;

      for (let j = itemsCounter; j < checkpoints.length; j += 1) {
        subitemsCounter += 1;

        subBatch.push(checkpoints[j]);
        if (subitemsCounter === itemsPerBatch) {
          break;
        }
      }

      itemsCounter += subitemsCounter;
      batches.push(subBatch);
      wayptsExist = itemsCounter < checkpoints.length;
      // If it runs again there are still points. Minus 1 before continuing to
      // start up with end of previous tour leg
      itemsCounter -= 1;
    }

    return batches;
  };

  _requestMapsPosition = ({
    request,
    batches,
    combinedResults,
    unsortedResults,
    attempts,
    batchesIndex,
  }) =>
    new Promise(resolve => {
      const directionsService = new google.maps.DirectionsService();
      // link to code source
      directionsService.route(request, (result, status) => {
        // request
        if (status === window.google.maps.DirectionsStatus.OK) {
          const unsortedResult = { order: batchesIndex, result }; // separa 1 obj numa var
          unsortedResults.push(unsortedResult); // e coloca no array

          directionsResultsReturned += 1;

          if (directionsResultsReturned === batches.length) {
            // we've received all the results. put to map
            // sort the returned values into their correct order
            unsortedResults.sort(
              (a, b) => parseFloat(a.order) - parseFloat(b.order),
            );
            let count = 0;

            for (const key in unsortedResults) {
              if (unsortedResults[key].result != null) {
                if (unsortedResults.hasOwnProperty(key)) {
                  if (count === 0) {
                    // first results. new up the combinedResults object
                    combinedResults = unsortedResults[key].result;
                  } else {
                    // only building up legs, overview_path, and bounds in my consolidated object. This is not a complete
                    // directionResults object, but enough to draw a path on the map, which is all I need
                    combinedResults.routes[0].legs =
                      combinedResults.routes[0].legs.concat(
                        unsortedResults[key].result.routes[0].legs,
                      );
                    combinedResults.routes[0].overview_path =
                      combinedResults.routes[0].overview_path.concat(
                        unsortedResults[key].result.routes[0].overview_path,
                      );

                    combinedResults.routes[0].bounds =
                      combinedResults.routes[0].bounds.extend(
                        unsortedResults[
                          key
                        ].result.routes[0].bounds.getNorthEast(),
                      );
                    combinedResults.routes[0].bounds =
                      combinedResults.routes[0].bounds.extend(
                        unsortedResults[
                          key
                        ].result.routes[0].bounds.getSouthWest(),
                      );
                  }
                  count += 1;
                }
              }
            }

            this.setState(prevState => ({
              isFetching: false,
              driverDirectionsServiceUI: {
                ...prevState.driverDirectionsServiceUI,
                data: combinedResults,
                status,
              },
            }));
          }
          resolve();
        } else if (
          status === google.maps.DirectionsStatus.OVER_QUERY_LIMIT &&
          attempts < 3
        ) {
          setTimeout(async () => {
            await this._requestMapsPosition({
              request,
              batches,
              combinedResults,
              unsortedResults,
              attempts: attempts + 1,
              batchesIndex,
            });
            resolve();
          }, 2000);
        } else if (status === google.maps.DirectionsStatus.ZERO_RESULTS) {
          resolve({ zeroResults: true });
        } else if (status === 'MAX_ROUTE_LENGTH_EXCEEDED') {
          resolve({ maxRouteLengthExceeded: true });
        } else {
          resolve({ apiError: true });
        }
      });
    });

  _sortMultiArray = async () => {
    const {
      manifestInformation: { checkpoints, driver },
      getErrorDetail,
    } = this.props;
    let combinedResults;
    const unsortedResults = [{}]; // to hold the counter and the results themselves as they come back, to later sort
    const batches = this._setMultiArray(checkpoints);
    // now we should have a 2 dimensional array with a list of a list of waypoints

    for (let k = 0; k < batches.length; k += 1) {
      const { waypointsWithDriver } = this._waypointsBuilder(batches[k], true);
      const origin = this._getOrigin(waypointsWithDriver);
      const destination = this._getDestination({
        driver,
        wasDriverAdded: false,
        waypoints: waypointsWithDriver,
      });

      const request = {
        // settando obj pra request
        origin,
        destination,
        waypoints: waypointsWithDriver,
        travelMode: google.maps.TravelMode.DRIVING,
      };

      const result = await this._requestMapsPosition({
        request,
        batches,
        combinedResults,
        unsortedResults,
        attempts: 0,
        batchesIndex: k,
      });

      if (result && result.zeroResults) {
        this.setState({
          isFetching: false,
          errorDetail: {
            message: ERROR_DETAIL.zeroResults.message,
            icon: ERROR_DETAIL.zeroResults.icon,
            color: ERROR_DETAIL.zeroResults.color,
            type: ERROR_TYPE.ZERO_RESULTS,
          },
        });
        break;
      }

      if (result && result.maxRouteLengthExceeded) {
        this.setState({
          isFetching: false,
          errorDetail: {
            message: ERROR_DETAIL.maxRouteLengthExceeded.message,
            icon: ERROR_DETAIL.maxRouteLengthExceeded.icon,
            color: ERROR_DETAIL.maxRouteLengthExceeded.color,
            type: ERROR_TYPE.MAX_ROUTE_LENGTH_EXCEEDED,
          },
        });
        break;
      }

      if (result && result.apiError) {
        getErrorDetail();
        break;
      }
    }
  };

  _setMapDirections = async () => {
    const {
      manifestInformation: { deliveries, driver },
      getErrorDetail,
    } = this.props;
    // MOCKADO -> deliveryPointsMock
    const { wasDriverAdded, waypointsWithDriver } =
      this._waypointsBuilder(deliveries);
    const origin = this._getOrigin(waypointsWithDriver);
    const destination = this._getDestination({
      driver,
      wasDriverAdded,
      waypoints: waypointsWithDriver,
    });
    this.setState({
      isFetching: true,
    });

    if (!origin || !destination) {
      this.setState({
        isFetching: false,
        errorDetail: {
          message: ERROR_DETAIL.noDeliveryPointAvailable.message,
          icon: ERROR_DETAIL.noDeliveryPointAvailable.icon,
          color: ERROR_DETAIL.noDeliveryPointAvailable.color,
          type: ERROR_TYPE.NO_DELIVERY_POINT_AVAILABLE,
        },
      });
      return;
    }

    const result = await this._getDirections({
      origin,
      destination,
      waypoints: waypointsWithDriver,
      propName: 'directionsServiceUI',
      attempts: 0,
    });

    if (result && result.zeroResults) {
      this.setState({
        isFetching: false,
        errorDetail: {
          message: ERROR_DETAIL.zeroResults.message,
          icon: ERROR_DETAIL.zeroResults.icon,
          color: ERROR_DETAIL.zeroResults.color,
          type: ERROR_TYPE.ZERO_RESULTS,
        },
      });
      return;
    }

    if (result && result.maxRouteLengthExceeded) {
      this.setState({
        isFetching: false,
        errorDetail: {
          message: ERROR_DETAIL.maxRouteLengthExceeded.message,
          icon: ERROR_DETAIL.maxRouteLengthExceeded.icon,
          color: ERROR_DETAIL.maxRouteLengthExceeded.color,
          type: ERROR_TYPE.MAX_ROUTE_LENGTH_EXCEEDED,
        },
      });
      return;
    }

    if (result && result.apiError) {
      getErrorDetail();
    }
  };

  _setDriverDirections = async () => {
    const {
      manifestInformation: { checkpoints, driver },
      getErrorDetail,
    } = this.props;
    this.setState({
      isFetching: true,
    });

    if (checkpoints && checkpoints.length >= 25) {
      this._sortMultiArray();
    } else {
      const { waypointsWithDriver } = this._waypointsBuilder(checkpoints, true);
      const origin = this._getOrigin(waypointsWithDriver);
      const destination = this._getDestination({
        driver,
        wasDriverAdded: false,
        waypoints: waypointsWithDriver,
      });

      if (!origin || !destination) {
        this.setState({
          isFetching: false,
          errorDetail: {
            message: ERROR_DETAIL.noDriverTracking.message,
            icon: ERROR_DETAIL.noDriverTracking.icon,
            color: ERROR_DETAIL.noDriverTracking.color,
            type: ERROR_TYPE.NO_DELIVERY_POINT_AVAILABLE,
          },
        });
        return;
      }

      const result = await this._getDirections({
        origin,
        destination,
        waypoints: waypointsWithDriver,
        propName: 'driverDirectionsServiceUI',
        attempts: 0,
      });

      if (result && result.zeroResults) {
        this.setState({
          isFetching: false,
          errorDetail: {
            message: ERROR_DETAIL.zeroResults.message,
            icon: ERROR_DETAIL.zeroResults.icon,
            color: ERROR_DETAIL.zeroResults.color,
            type: ERROR_TYPE.ZERO_RESULTS,
          },
        });
        return;
      }

      if (result && result.maxRouteLengthExceeded) {
        this.setState({
          isFetching: false,
          errorDetail: {
            message: ERROR_DETAIL.maxRouteLengthExceeded.message,
            icon: ERROR_DETAIL.maxRouteLengthExceeded.icon,
            color: ERROR_DETAIL.maxRouteLengthExceeded.color,
            type: ERROR_TYPE.MAX_ROUTE_LENGTH_EXCEEDED,
          },
        });
        return;
      }

      if (result && result.apiError) {
        getErrorDetail();
      }
    }
  };

  _getOrigin = checkpoints =>
    checkpoints && checkpoints.length ? checkpoints.shift().location : null;

  _getDestination = ({ driver = {}, wasDriverAdded, waypoints }) => {
    if (wasDriverAdded) {
      return waypoints.pop().location;
    }

    return {
      lat: driver && driver.currentLatitude,
      lng: driver && driver.currentLongitude,
    };
  };

  _getDirections = ({ origin, destination, waypoints, propName, attempts }) =>
    new Promise((resolve, reject) => {
      const directionsService = new google.maps.DirectionsService();
      this.setState({
        isFetching: true,
      });

      if (!origin || !destination) {
        reject();
        return;
      }

      directionsService.route(
        {
          origin,
          destination,
          travelMode: google.maps.TravelMode.DRIVING, // Travelmode = CAR
          waypoints,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.setState(prevState => ({
              isFetching: false,
              [propName]: {
                ...prevState[propName],
                data: result,
                status,
              },
            }));
            resolve();
          } else if (
            status === google.maps.DirectionsStatus.OVER_QUERY_LIMIT &&
            attempts < 3
          ) {
            setTimeout(() => {
              this._getDirections({
                origin,
                destination,
                waypoints,
                propName,
                attempts: attempts + 1,
              });
              resolve();
            }, 2000);
          } else if (status === google.maps.DirectionsStatus.ZERO_RESULTS) {
            resolve({ zeroResults: true });
          } else if (status === 'MAX_ROUTE_LENGTH_EXCEEDED') {
            resolve({ maxRouteLengthExceeded: true });
          } else {
            resolve({ apiError: true });
          }
        },
      );
    });

  _waypointsBuilder = (points, hasDriver = false) => {
    const {
      manifestInformation: { driver },
    } = this.props;
    const waypoints = (points || []).map(
      ({ latitude: lat, longitude: lng, delivered }) => ({
        location: { lat, lng },
        delivered,
        stopover: false,
      }),
    );
    let wasDriverAdded = hasDriver;
    const waypointsWithDriver = waypoints.reduce((acc, waypoint) => {
      if (
        acc.length > 0 &&
        acc[acc.length - 1].location.lat === waypoint.location.lat &&
        acc[acc.length - 1].location.lng === waypoint.location.lng
      ) {
        return acc;
      }

      if (!waypoint.delivered && !wasDriverAdded) {
        acc.push({
          location: {
            lat: driver && driver.checkpoints[0].latitude, // Apartir da posição inicial e nao atual
            // -disable-next-line no-irregular-whitespace
            lng: driver && driver.checkpoints[0].longitude, // Apartir da posição inicial e nao atual
          },
          stopover: false,
        });
        wasDriverAdded = true;
        acc.push({
          location: {
            ...waypoint.location,
          },
          stopover: waypoint.stopover,
        });
        return acc;
      }
      acc.push({
        location: {
          ...waypoint.location,
        },
        stopover: waypoint.stopover,
      });
      return acc;
    }, []);

    return {
      wasDriverAdded,
      waypointsWithDriver,
    };
  };

  _checkIsDelivered = markerInfoList =>
    markerInfoList &&
    markerInfoList.length > 0 &&
    markerInfoList.some(el => {
      if (el.finishedDate) {
        return true;
      }
      return false;
    });

  _markerListBuilder = () => {
    const {
      manifestInformation: { deliveries = [], driver = {} },
    } = this.props;
    let markerInfoList = [];

    return (deliveries || []).reduce(
      (acc, delivery, index) => {
        const accLength = acc.length;

        if (
          acc[accLength - 1].latitude === delivery.latitude &&
          acc[accLength - 1].longitude === delivery.longitude
        ) {
          markerInfoList.push({
            ...delivery,
            key: new Date() + index,
          });

          acc[accLength - 1] = {
            ...delivery,
            key: new Date() + index,
            url:
              this._checkIsDelivered(markerInfoList) === true
                ? iconDelivered
                : iconAwaitingDelivery,
            markerInfoList,
          };
        } else {
          markerInfoList = [
            {
              ...delivery,
              key: new Date() + index,
            },
          ];
          acc.push({
            ...delivery,
            key: new Date() + index,
            url: delivery.finishedDate ? iconDelivered : iconAwaitingDelivery,
            markerInfoList,
          });
        }
        return acc;
      },
      [
        {
          latitude: driver.currentLatitude,
          longitude: driver.currentLongitude,
          key: new Date(),
          url: iconDriver,
        },
      ],
    );
  };

  _getDeliveryInfo = (e, markerInfoList) => {
    this.setState(
      prevState => ({
        activeDeliveryPointInfo: {
          ...prevState.activeDeliveryPointInfo,
          isVisible: true,
          data: markerInfoList,
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        },
      }),
      () => {
        const {
          activeDeliveryPointInfo: { lat, lng },
        } = this.state;

        this._offsetCenter(lat, lng, mapCenterCalculate(848), 0);
      },
    );
  };

  _closeDeliveryInfo = () => {
    this.setState(prevState => ({
      activeDeliveryPointInfo: {
        ...prevState.activeDeliveryPointInfo,
        isVisible: false,
        data: [],
        lat: null,
        lng: null,
      },
    }));
  };

  _offsetCenter(lat, lng, offsetx, offsety) {
    const scale = Math.pow(2, this.mapRef.getZoom());

    const pixelOffset = new google.maps.Point(
      offsetx / scale || 0,
      offsety / scale || 0,
    );

    this.setState({
      mapCenter: {
        lat: lat + pixelOffset.y,
        lng: lng + pixelOffset.x,
      },
    });
  }

  _renderDeliveryMarkers = () => {
    const driverAndDeliveriesMarkers = this._markerListBuilder();

    return driverAndDeliveriesMarkers.map(
      ({ latitude: lat, longitude: lng, key, url, markerInfoList }, index) => (
        <Marker
          name="SOMA"
          label={{
            text: `${index}`,
            color: 'white',
            fontSize: '16px',
            fontWeight: 'bold',
            textAlign: 'center',
            paddingBottom: '10px',
          }}
          position={{ lat, lng }}
          key={key}
          icon={{ url }}
          onClick={e => this._getDeliveryInfo(e, markerInfoList)}
        />
      ),
    );
  };

  // -disable-next-line consistent-return
  _renderDriverRoutes = () => {
    const {
      driverDirectionsServiceUI: { data },
    } = this.state;
    if (data) {
      return (
        <DirectionsRenderer
          options={{
            suppressMarkers: true,
            suppressInfoWindows: true,
            polylineOptions: {
              strokeColor: DRIVER_ROUTE_COLOR,
              strokeOpacity: DEFAULT_STROKE_OPACITY,
              strokeWeight: DEFAULT_STROKE_WEIGHT,
            },
          }}
          directions={data}
        />
      );
    }
  };

  _renderMapRoutes = () => {
    const {
      directionsServiceUI: { data },
    } = this.state;
    if (data) {
      return (
        <DirectionsRenderer
          options={{
            suppressMarkers: true,
            suppressInfoWindows: true,
            polylineOptions: {
              strokeColor: MAP_ROUTE_COLOR,
              strokeOpacity: DEFAULT_STROKE_OPACITY,
              strokeWeight: DEFAULT_STROKE_WEIGHT,
            },
          }}
          directions={data}
        />
      );
    }
  };

  render() {
    const { isFetching, errorDetail } = this.state;

    return (
      <GoogleMap
        id="map-google"
        ref={map => {
          this.mapRef = map;
        }}
        defaultZoom={8}
        defaultCenter={{
          lat: -5.0448,
          lng: -37.37,
        }}
        style={{ display: 'none' }}
        defaultOptions={{
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        }}
        center={{
          lat: this.state.mapCenter.lat,
          lng: this.state.mapCenter.lng,
        }}
      >
        {isFetching && (
          <LoaderContainer>
            <LoadingIndicator text="Carregando..." theme="dark" />
          </LoaderContainer>
        )}
        {errorDetail.message && (
          <ThrowMapError
            message={errorDetail.message}
            icon={errorDetail.icon}
            color={errorDetail.color}
          />
        )}
        {this._renderDeliveryMarkers()}
        {this._renderMapRoutes()}
        {this._renderDriverRoutes()}
        {this.state.activeDeliveryPointInfo.isVisible && (
          <CustomOverlayView
            position={{
              lat: this.state.activeDeliveryPointInfo.lat,
              lng: this.state.activeDeliveryPointInfo.lng,
            }}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <DeliveryPointInfo
              onDismiss={this._closeDeliveryInfo}
              onClick={e => {
                e.stopPropagation();
              }}
              deliveryPointData={this.state.activeDeliveryPointInfo.data}
              isDelivered={this._checkIsDelivered(
                this.state.activeDeliveryPointInfo.data,
              )}
            />
          </CustomOverlayView>
        )}
      </GoogleMap>
    );
  }
}

export default withScriptjs(withGoogleMap(Map));
